'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validDomain = require('./validDomain');

var _validDomain2 = _interopRequireDefault(_validDomain);

var _validPortNumber = require('./validPortNumber');

var _validPortNumber2 = _interopRequireDefault(_validPortNumber);

var _validUrlPath = require('./validUrlPath');

var _validUrlPath2 = _interopRequireDefault(_validUrlPath);

var _validUrlPrecedingChars = require('./validUrlPrecedingChars');

var _validUrlPrecedingChars2 = _interopRequireDefault(_validUrlPrecedingChars);

var _validUrlQueryChars = require('./validUrlQueryChars');

var _validUrlQueryChars2 = _interopRequireDefault(_validUrlQueryChars);

var _validUrlQueryEndingChars = require('./validUrlQueryEndingChars');

var _validUrlQueryEndingChars2 = _interopRequireDefault(_validUrlQueryEndingChars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extractUrl = (0, _regexSupplant2.default)('(' + // $1 total match
'(#{validUrlPrecedingChars})' + // $2 Preceeding chracter
'(' + // $3 URL
'(https?:\\/\\/)?' + // $4 Protocol (optional)
'(#{validDomain})' + // $5 Domain(s)
'(?::(#{validPortNumber}))?' + // $6 Port number (optional)
'(\\/#{validUrlPath}*)?' + // $7 URL Path
'(\\?#{validUrlQueryChars}*#{validUrlQueryEndingChars})?' + // $8 Query String
')' + ')', {
  validUrlPrecedingChars: _validUrlPrecedingChars2.default,
  validDomain: _validDomain2.default,
  validPortNumber: _validPortNumber2.default,
  validUrlPath: _validUrlPath2.default,
  validUrlQueryChars: _validUrlQueryChars2.default,
  validUrlQueryEndingChars: _validUrlQueryEndingChars2.default
}, 'gi'); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = extractUrl;
module.exports = exports['default'];